// import wx from './lib/jweixin-1.4.0';
import { $Jsonp } from './lib/request';
/**
 * ============================================================================
 * 微信环境初始化
 * ============================================================================
 */

var wxEnvir = function () {
  if (!window.kgWxEnvir) {
    window.kgWxEnvir = new KGWxEnvir();
    window.hash = window.location.hash;
    pageHashChange();
  }

  function init(cb, options) {
    window.kgWxEnvir.init(options, cb);
  }

  function share(shareData) {
    window.kgWxEnvir.share(shareData);
  }

  function getUserInfo(data) {
    function getWxLoginUrl(options) {
      var url = window.location.href;
      var redirect_uri = encodeURIComponent("https://mwechats.kugou.com/service/user/getInfo?redirect_uri=" + encodeURIComponent(url));
      var appid = options.appid || "wx412c15698d95020e";
      return "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
    }

    if (/MicroMessenger/i.test(navigator.userAgent)) {
      var search = decodeURIComponent(window.location.search),
          searchP;

      if (search == "" && window.location.hash && window.location.hash.indexOf("?") != -1) {
        search = "?" + decodeURIComponent(window.location.hash).split("?")[1];
      }

      if (search.indexOf("openid") != -1 && search.indexOf("unionid") != -1) {
        var userInfo = {
          openid: "",
          unionid: "",
          nickname: "",
          sex: "",
          city: "",
          province: "",
          country: "",
          headimgurl: ""
        };
        search = search.substr(1).split("&");

        for (var i = 0; i < search.length; i++) {
          searchP = search[i];

          if (searchP.indexOf("openid") != -1) {
            searchP = searchP.substring(searchP.indexOf("openid"));
          }

          searchP = searchP.split("=");

          if (searchP.length > 1) {
            if (userInfo[searchP[0]] != undefined) {
              userInfo[searchP[0]] = searchP[1];
            }
          }
        }

        return userInfo;
      } else {
        //重定向
        window.location.href = getWxLoginUrl(data || {});
        return undefined;
      }
    }

    return null;
  } //监听页面hash变化


  function pageHashChange() {
    if ("onhashchange" in window && (typeof document.documentMode === "undefined" || document.documentMode == 8)) {
      // 浏览器支持onhashchange事件
      window.onhashchange = function () {
        window.kgWxEnvir.hasCheck = false;
        window.kgWxEnvir.hasRegister = false;
        window.kgWxEnvir.hasReady = false;
        window.kgWxEnvir.init();
      };
    } else {
      // 不支持则用定时器检测的办法
      setInterval(function () {
        if (window.location.hash != window.hash) {
          window.hash = window.location.hash;
          window.kgWxEnvir.hasCheck = false;
          window.kgWxEnvir.hasRegister = false;
          window.kgWxEnvir.hasReady = false;
          window.kgWxEnvir.init();
        }
      }, 150);
    }
  } //微信初始化对象


  function KGWxEnvir() {
    //新增新、旧两种分享方式, add by sunzhang at 2020.2.11
    var domain_old = ["m3ws.kugou.com", "ep.kugou.com", "activity.kugou.com", "h5.kugou.com", "m.kugou.com"];
    var domain_new = ["m3ws.kugou.com", "mtpls.kugou.com", "h5.kugou.com", "m.kugou.com"];
    var host = window.location.host;

    if (domain_old.join(",").indexOf(host) != -1) {
      //走原来的分享流程
      this.useNewShare = false;
    } else if (domain_new.join(",").indexOf(host) != -1) {
      //走新的分享流程
      this.useNewShare = true;
    } else {
      //域名都未命中，还是走原来的分享流程
      this.useNewShare = false;
      this.OffTheWhiteList = true;
    }

    this.hasCheck = false; //开始获取微信参数

    this.hasRegister = false; //是否初始化

    this.hasReady = false; //微信环境准备完成

    this.cbBus = []; //回调函数站
    //微信默认注册函数

    this.jsApiList = ['launchApplication', // 打开第三方app
    "onMenuShareTimeline", // 分享朋友圈
    "onMenuShareAppMessage", // 分享给朋友
    "onMenuShareQQ", // 分享到QQ
    "onMenuShareWeibo", // 分享到腾讯微博
    "onMenuShareQZone", // 分享到QQ空间
    "updateAppMessageShareData", "updateTimelineShareData"]; //微信sdk版本

    this.version = "1.4";
  }

  KGWxEnvir.prototype.init = function (options, cb) {
    if (!/MicroMessenger/i.test(navigator.userAgent)) return;

    if (options && options.jsApiList && Array.isArray(options.jsApiList)) {
      this.jsApiList = this.jsApiList.concat(options.jsApiList);
    }

    if (options && options.version) {
      this.version = options.version;
    }

    if (window.location.origin.indexOf("kugou.com") != -1) {
      this.this_url = encodeURIComponent(window.location.href);
    } else {
      this.this_url = encodeURIComponent('http://kugou.com');
    }

    var _this = this;

    _this.loadWxJs(function () {
      if (_this.hasReady) {
        cb && cb(window.wx);
      } else {
        _this.cbBus.push(cb);

        if (_this.hasCheck) {
          return;
        } //延迟500毫秒再进行微信注册，确保所有初始化调用时注入的jsApiList都已完成


        if (_this.wxRegisterTimeout) {
          clearTimeout(_this.wxRegisterTimeout);
        }

        _this.wxRegisterTimeout = setTimeout(function () {
          _this.hasCheck = true;

          _this.getSignature();
        }, 500);
      }
    }); //提前加载apm上报的stat.js


    _this.loadStatJs();
  };

  KGWxEnvir.prototype.loadStatJs = function (fn) {
    if (window.kgStatPush || this.hasLoadStatJS) {
      fn && fn();
    } else {
      var script = document.createElement('script');
      script.type = 'text/javascript';

      if (script.readyState) {
        script.onreadystatechange = function () {
          this.hasLoadStatJS = true;

          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;
            fn && fn();
          }
        };
      } else {
        //其他浏览器
        script.onload = function () {
          this.hasLoadStatJS = true;
          fn && fn();
        };
      }

      script.src = "https://staticssl.kugou.com/common/js/min/npm/stat.min.js";
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  };

  KGWxEnvir.prototype.pushAPM = function (data) {
    var _this = this;

    if (window.location.host == "voo.kugou.com" || window.location.host == "test.kugou.com") {
      // 测试环境，开发环境，不上报
      return null;
    }

    data.ver = 1000;
    data.useragent = navigator.userAgen;
    data.os = 1058;
    data.timestamp = +new Date();

    _this.loadStatJs(function () {
      kgStatPush(data, 1);
    });
  };

  KGWxEnvir.prototype.loadWxJs = function (fn) {
    if (window.wx || this.hasLoadJS) {
      fn && fn();
    } else {
      this.hasLoadJS = true;
      var script = document.createElement('script');
      script.type = 'text/javascript';

      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;
            fn && fn();
          }
        };
      } else {
        //其他浏览器
        script.onload = function () {
          fn && fn();
        };
      }

      if (this.version === "1.6") {
        script.src = "https://staticssl.kugou.com/common/js/kg-jweixin-1.6.0.js";
      } else {
        script.src = "https://staticssl.kugou.com/common/js/kg-jweixin-1.4.0.js";
      }

      document.getElementsByTagName('head')[0].appendChild(script);
    }
  };

  KGWxEnvir.prototype.getSignature = function () {
    var _this = this;

    if (_this.OffTheWhiteList) {
      // 域名在白名单之外，上报
      if (window.location.host != "voo.kugou.com" || window.location.host != "test.kugou.com") {
        // voo 这两个不上报
        _this.pushAPM({
          typeid: 110493,
          state: 0,
          te: 'E1',
          position: 3,
          fs: window.location.host,
          hash: window.location.href
        });
      }
    }

    if (!_this.useNewShare) {
      $Jsonp({
        url: 'https://mwechats.kugou.com/jssdk/getSignature?sdk=140&caller=kugou_mobile&url=' + _this.this_url,
        success: function success(callbackData) {
          if (callbackData) {
            /*微信分享设置*/
            window.wx.config({
              debug: false,
              beta: true,
              appId: callbackData.appId,
              timestamp: callbackData.timestamp,
              nonceStr: callbackData.nonceStr,
              signature: callbackData.signature,
              jsApiList: _this.jsApiList
            });
            _this.hasRegister = true;
            window.wx.ready(function () {
              _this.hasReady = true;

              _this.cbBus.forEach(function (cb) {
                cb && cb(window.wx);
              });
            });
            window.wx.error(function (res) {
              try {
                res = JSON.stringify(res);
              } catch (error) {} // 上报 apm ，微信sdk失败


              _this.pushAPM({
                typeid: 110493,
                state: 0,
                te: 'E1',
                position: 1,
                fs: res || 0,
                hash: window.location.href
              });
            });
          }
        }
      });
    } else {
      $Jsonp({
        url: 'https://mwechats.kugou.com/service/jssdk/getSignature?sdk=140&caller=kugou_web&url=' + _this.this_url,
        success: function success(callbackData) {
          // console.log('getSignature res', callbackData);
          if (callbackData) {
            window.wx.config({
              beta: true,
              debug: false,
              //调试时改为true
              appId: callbackData.appId,
              timestamp: callbackData.timestamp,
              nonceStr: callbackData.nonceStr,
              signature: callbackData.signature,
              jsApiList: _this.jsApiList
            });
            _this.hasRegister = true;
            window.wx.ready(function () {
              _this.hasReady = true;

              _this.cbBus.forEach(function (cb) {
                cb && cb(window.wx);
              });
            });
            window.wx.error(function (res) {
              try {
                res = JSON.stringify(res);
              } catch (error) {}

              _this.pushAPM({
                typeid: 110493,
                state: 0,
                te: 'E1',
                position: 2,
                fs: res || 0,
                hash: window.location.href
              });
            });
          }
        }
      });
    }
  };

  KGWxEnvir.prototype.share = function (shareData) {
    var _this = this;

    if (!this.hasRegister) {
      return "还未完成初始化，请在init回调中调用share方法";
    }

    window.wx.ready(function () {
      if (!shareData.title) {
        _this.pushAPM({
          typeid: 110493,
          state: 0,
          te: 'E1',
          position: 5,
          fs: "no_title",
          hash: window.location.href
        });
      }

      if (!shareData.content) {
        _this.pushAPM({
          typeid: 110493,
          state: 0,
          te: 'E1',
          position: 6,
          fs: "no_content",
          hash: window.location.href
        });
      }

      if (!shareData.img) {
        _this.pushAPM({
          typeid: 110493,
          state: 0,
          te: 'E1',
          position: 7,
          fs: "no_img",
          hash: window.location.href
        });
      } //分享给朋友


      window.wx.onMenuShareAppMessage({
        title: shareData.title,
        desc: shareData.content,
        link: shareData.url,
        imgUrl: shareData.img,
        trigger: function trigger(res) {},
        success: function success(res) {},
        cancel: function cancel(res) {},
        fail: function fail(res) {}
      }); // 分享朋友圈

      window.wx.onMenuShareTimeline({
        title: shareData.title,
        desc: shareData.content,
        link: shareData.url,
        imgUrl: shareData.img,
        trigger: function trigger(res) {},
        success: function success(res) {},
        cancel: function cancel(res) {},
        fail: function fail(res) {}
      });
      window.wx.onMenuShareQQ({
        title: shareData.title,
        // 分享标题
        desc: shareData.content,
        // 分享描述
        link: shareData.url,
        // 分享链接
        imgUrl: shareData.img,
        // 分享图标
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.onMenuShareQZone({
        title: shareData.title,
        // 分享标题
        desc: shareData.content,
        // 分享描述
        link: shareData.url,
        // 分享链接
        imgUrl: shareData.img,
        // 分享图标
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.onMenuShareWeibo({
        title: shareData.title,
        // 分享标题
        desc: shareData.content,
        // 分享描述
        link: shareData.url,
        // 分享链接
        imgUrl: shareData.img,
        // 分享图标
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.updateAppMessageShareData({
        title: shareData.title,
        // 分享标题
        desc: shareData.content,
        // 分享描述
        link: shareData.url,
        // 分享链接
        imgUrl: shareData.img,
        // 分享图标
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.updateTimelineShareData({
        title: shareData.title,
        // 分享标题
        desc: shareData.content,
        // 分享描述
        link: shareData.url,
        // 分享链接
        imgUrl: shareData.img,
        // 分享图标
        success: function success() {},
        cancel: function cancel() {}
      });

      if (parseInt(Math.random() * 10) !== 8) {
        return;
      } // 上报 apm , 成功抽量10%


      _this.pushAPM({
        typeid: 110493,
        state: 1,
        hash: window.location.href
      });
    });
  };

  return {
    init: init,
    share: share,
    getUserInfo: getUserInfo
  };
}();

export default wxEnvir;